import React from "react";
import BibleReader from "./BibleReader";

export default function BibleIsReader() {
  return <BibleReader source="bibleis" />;
}

